"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4904],{

/***/ 2017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ createClient; }
/* harmony export */ });
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61970);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_0__);


var createClient = function createClient() {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  return algoliasearch__WEBPACK_IMPORTED_MODULE_0___default()((_process$env$NEXT_PUB = "16K0JFOELG") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "", (_process$env$NEXT_PUB2 = "d8d6f81bd62f98b1e42cce94c827afd2") !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "");
};



/***/ }),

/***/ 97946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nv": function() { return /* binding */ useCatalogSearchIndex; },
/* harmony export */   "TO": function() { return /* binding */ useCatalogIndex; },
/* harmony export */   "jH": function() { return /* binding */ useCatalogAlphaIndex; },
/* harmony export */   "sR": function() { return /* binding */ CatalogClientProvider; }
/* harmony export */ });
/* unused harmony exports CatalogClientContext, useCatalogClient, createCatalogIndex, createCatalogAlphaIndex, createCatalogSearchIndex */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var CatalogClientContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var CatalogClientProvider = CatalogClientContext.Provider;
var useCatalogClient = function useCatalogClient() {
  var catalogClient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CatalogClientContext);

  if (!catalogClient) {
    throw new Error("Catalog index isn't available. Please set it via CatalogClientProvider component.");
  }

  return catalogClient;
};
var useCatalogIndex = function useCatalogIndex() {
  var client = useCatalogClient();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return createCatalogIndex(client);
  }, [client]);
};
var createCatalogIndex = function createCatalogIndex(client) {
  var _process$env$NEXT_PUB;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB = "Catalog: Category Alphabetical") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "");
};
var useCatalogAlphaIndex = function useCatalogAlphaIndex() {
  var client = useCatalogClient();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return createCatalogAlphaIndex(client);
  }, [client]);
};
var createCatalogAlphaIndex = function createCatalogAlphaIndex(client) {
  var _process$env$NEXT_PUB2;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB2 = "Catalog: Alphabetical") !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "");
};
var useCatalogSearchIndex = function useCatalogSearchIndex() {
  var client = useCatalogClient();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return createCatalogSearchIndex(client);
  }, [client]);
};
var createCatalogSearchIndex = function createCatalogSearchIndex(client) {
  var _process$env$NEXT_PUB3;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB3 = "Catalog") !== null && _process$env$NEXT_PUB3 !== void 0 ? _process$env$NEXT_PUB3 : "");
};

/***/ }),

/***/ 97536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ct": function() { return /* reexport */ Badge_Badge; },
  "dk": function() { return /* reexport */ Description_Description; },
  "TR": function() { return /* reexport */ Logo; },
  "K7": function() { return /* reexport */ LogoWrapper; },
  "VG": function() { return /* reexport */ Name_Name; },
  "X2": function() { return /* reexport */ Row; },
  "ZP": function() { return /* reexport */ IntegrationCard; }
});

// UNUSED EXPORTS: Content

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/IntegrationCard.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ez5x58p1"
} : 0)("display:grid;gap:30px;width:100%;position:relative;padding:", function (_ref) {
  var padding = _ref.padding;
  return padding;
}, ";border-radius:8px;background-color:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";box-shadow:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadows[3];
}, ";text-decoration:none;transition:box-shadow 0.3s ease;", function (_ref4) {
  var hoverable = _ref4.hoverable,
      chevronHoverColor = _ref4.chevronHoverColor;
  return hoverable &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(":hover{box-shadow:0px 3px 6px rgba(0, 0, 0, 0.02),0px 10px 19px rgba(7, 14, 74, 0.09),0px 41px 16px -39px rgba(53, 36, 70, 0.05);", IconWrapper, "{path[fill='none'],path:not([fill]){fill:", chevronHoverColor, ";}}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ez5x58p0"
} : 0)( true ? {
  name: "159u4b7",
  styles: "position:absolute;bottom:0;right:0;padding:16px;svg{path[fill='none'],path:not([fill]){transition:fill 0.3s ease;}}"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/IntegrationCard.tsx


var _excluded = ["href", "children", "tokens", "appearance", "padding", "onClick"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









var BaseIntegrationCard = /*#__PURE__*/(0,react.forwardRef)( // eslint-disable-next-line @typescript-eslint/no-unused-vars
function (_ref, ref) {
  var href = _ref.href,
      children = _ref.children,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      _ = _ref.padding,
      onClick = _ref.onClick,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var integrationCardAppearance = appearance === "twilioLight" ? "twilioLight" : "light";
  return href ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: href,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      hoverable: true
    }, tokens), {}, {
      onClick: onClick
    }, rest), {}, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {
          size: "medium",
          color: tokens.chevronColor
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
        appearance: integrationCardAppearance,
        children: children
      })]
    }))
  }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread(_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: integrationCardAppearance,
      children: children
    })
  }));
});
var paddingSizes = {
  small: "18px",
  large: "32px"
};
var IntegrationCard = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIntegrationCard, function (_ref2, theme) {
  var _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? "small" : _ref2$padding;
  return {
    padding: paddingSizes[padding],
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      chevronColor: theme.palette.brand.darkAcai[400],
      chevronHoverColor: theme.palette.brand.darkAcai[600]
    };
  },
  dark: function dark(theme) {
    return {
      chevronColor: theme.palette.brand.darkAcai[400],
      chevronHoverColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      chevronColor: theme.palette.twilio.gray[40],
      chevronHoverColor: theme.palette.twilio.gray[100]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Row/Row.tsx

var Row = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed0so160"
} : 0)("width:100%;display:grid;justify-items:", function (_ref) {
  var centered = _ref.centered;
  return centered && "center";
}, ";align-items:center;&:last-of-type{padding-right:20px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Row/index.ts

// EXTERNAL MODULE: ../../libs/utils/contentfulImageLoader/contentfulImageLoader.ts
var contentfulImageLoader = __webpack_require__(1959);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Logo/Logo.views.ts


var Logo_views_Logo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "empkmi90"
} : 0)("max-height:32px;max-width:calc(100% - 16px);height:auto;width:auto;margin:0 auto;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{max-height:48px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Logo/Logo.tsx



var defaultImageSizes = {
  width: 136,
  height: 48
};
var Logo = function Logo(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo_views_Logo, {
    loader: contentfulImageLoader/* default */.Z,
    width: width && height ? width : defaultImageSizes.width,
    height: width && height ? height : defaultImageSizes.height,
    loading: "lazy",
    src: src,
    alt: alt || ""
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Logo/index.ts

// EXTERNAL MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(86015);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Name/Name.views.ts


var Name = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0,emotion_is_prop_valid_esm/* default */.Z)(prop) && prop !== "color";
  },
  target: "e11xcj1q0"
} : 0)("white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{", function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.buttonLarge;
}, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Name/Name.tsx


var Name_excluded = ["tokens"];

function Name_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Name_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Name_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Name_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseName = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Name_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, Name_objectSpread(Name_objectSpread({
    ref: ref
  }, tokens), props));
});
var Name_Name = (0,useDesignTokens/* withDesignTokens */.Y)(BaseName, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[600]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Name/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Badge/Badge.views.ts


function Badge_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Badge_views_Badge = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Badge/* default */.Z,  true ? {
  target: "e1bsms7i0"
} : 0)( true ? {
  name: "1r0wq0g",
  styles: "position:absolute;top:8px;right:8px;text-transform:uppercase"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Badge/Badge.tsx


var Badge_excluded = ["children", "variant"];

function Badge_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Badge_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Badge_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Badge_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Badge_Badge = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filledGreen" : _ref$variant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Badge_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge_views_Badge, Badge_objectSpread(Badge_objectSpread({
    variant: variant,
    ref: ref,
    tag: "div"
  }, rest), {}, {
    children: children
  }));
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Badge/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Description/Description.views.ts


var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0,emotion_is_prop_valid_esm/* default */.Z)(prop) && prop !== "color";
  },
  target: "e1q5ntsr0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.textRegularSmall;
}, ";color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";padding-top:4px;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Description/Description.tsx


var Description_excluded = ["tokens"];

function Description_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Description_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Description_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Description_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseDescription = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Description_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, Description_objectSpread(Description_objectSpread({
    ref: ref
  }, tokens), props));
});
var Description_Description = (0,useDesignTokens/* withDesignTokens */.Y)(BaseDescription, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[60]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Description/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Content/Content.views.ts


function Content_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1nnpfoy0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Content/Content.tsx


var Content_excluded = ["children"];

function Content_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Content_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Content_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Content_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Content_Content = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Content_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, Content_objectSpread(Content_objectSpread({
    ref: ref,
    variant: "pLarge"
  }, rest), {}, {
    children: children
  }));
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/Content/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/LogoWrapper/LogoWrapper.tsx

var LogoWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eacljvk0"
} : 0)("display:flex;justify-content:center;align-items:center;max-width:128px;height:auto;max-height:32px;width:100%;margin-top:25px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{max-width:136px;max-height:48px;height:48px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/LogoWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/IntegrationCard/index.ts








IntegrationCard.displayName = "IntegrationCardBase";
Row.displayName = "IntegrationCard.Row";
Logo.displayName = "IntegrationCard.Logo";
Name_Name.displayName = "IntegrationCard.Name";
Badge_Badge.displayName = "IntegrationCard.Badge";
Description_Description.displayName = "IntegrationCard.Description";
Content_Content.displayName = "IntegrationCard.Content";
LogoWrapper.displayName = "IntegrationCard.LogoWrapper";


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ })

}]);